module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/strumenti_big.2eb50c98.png";